import type { NativeStackNavigationOptions } from '@react-navigation/native-stack';
import type { StackNavigationOptions } from '@react-navigation/stack';
import { IconX } from '@tabler/icons-react-native';
import { Platform } from 'react-native';
import { Button } from 'app/design/primitives/button';
import { i18n } from 'app/localization/i18n';
import { createTheme as createDSTheme } from 'app/shopify';
import type { ScreenOptionsNavigationProp, SpecificRouteProp } from 'app/types/navigation';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { LogoComponent } from './mobile/logo';

const theme = createDSTheme();

export function createScreenOptions(route: SpecificRouteProp): NativeStackNavigationOptions | StackNavigationOptions {
  return {
    headerTitleAlign: 'center',
    headerTitle: i18n.exists('headerTitle', { ns: route.name })
      ? i18n.t('headerTitle', { ns: route.name })
      : () => <LogoComponent />,
  };
}

export function createModalScreenOptions(
  navigation: ScreenOptionsNavigationProp,
  route: SpecificRouteProp,
  useBackButton?: boolean,
  headerShown?: boolean,
): NativeStackNavigationOptions {
  const screenOptions = createScreenOptions(route) as NativeStackNavigationOptions;

  screenOptions.headerShown = headerShown !== false;
  screenOptions.headerShadowVisible = false;
  screenOptions.headerStyle = { backgroundColor: theme.colors['white-label.header.bg'] };
  screenOptions.headerTitleStyle = { color: theme.colors['white-label.header.on-header'] };
  screenOptions.headerTintColor = theme.colors['white-label.header.on-header'];
  screenOptions.headerRight = () => null;

  if (i18n.exists('headerTitle', { ns: route.name })) {
    screenOptions.headerTitle = i18n.t('headerTitle', { ns: route.name });
  } else {
    screenOptions.headerTitle = '';
  }

  if (Platform.OS === 'ios') {
    screenOptions.headerBackVisible = false;
  }

  if (!useBackButton) {
    screenOptions.headerLeft = () => (
      <Button onPress={navigation.goBack} testID="modal-close-button">
        <IconX strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['white-label.header.on-header']} />
      </Button>
    );
  }

  return screenOptions;
}
